var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.462,
    height: 15.462,
    viewBox: "0 0 15.462 15.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-alarm",
    d: "M9.731,4.029A6.179,6.179,0,0,0,4.883,14.047a.6.6,0,0,0-.071.048l-2.005,2.03a.789.789,0,0,0,0,1.107.765.765,0,0,0,1.093,0L5.9,15.2a.753.753,0,0,0,.059-.09,6.155,6.155,0,0,0,7.534,0,.794.794,0,0,0,.06.09l2.005,2.028a.765.765,0,0,0,1.093,0,.789.789,0,0,0,0-1.107l-2.005-2.03c-.021-.021-.049-.029-.071-.048A6.179,6.179,0,0,0,9.731,4.029Zm3.092,6.958H9.731a.773.773,0,0,1-.773-.773V6.5a.773.773,0,1,1,1.546,0V9.441h2.319a.773.773,0,0,1,0,1.546Zm-10.6-5.3a.789.789,0,0,1,0-1.107L4.546,2.23a.765.765,0,0,1,1.093,0,.789.789,0,0,1,0,1.107L3.32,5.685a.767.767,0,0,1-1.093,0ZM17.235,4.578a.789.789,0,0,1,0,1.107.767.767,0,0,1-1.093,0L13.823,3.337a.789.789,0,0,1,0-1.107.765.765,0,0,1,1.093,0Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoAlarm);
export default __webpack_public_path__ + "static/media/so-alarm.a70c662314d01e0c125db8abb67909e3.svg";
export { ForwardRef as ReactComponent };